import { TextWidth, TextWidthExtended } from 'components/Container'
import React, { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const Image = ({
  src,
  title,
  caption,
  source,
  colorMode = 'light',
}: {
  src?: string
  title?: string
  caption?: string
  source?: string
  colorMode?: 'light' | 'dark'
}) => {
  const { width } = useWindowSize()
  const content = (
    <FigCaption>
      {title && <Title>{title}</Title>}
      {caption && <Caption>{caption}</Caption>}
      {source && <Source>{source}</Source>}
    </FigCaption>
  )
  return (
    <>
      <Figure>
        <TextWidthExtended>
          {!src && <Placeholder />}
          {src && <_Image src={src} />}
        </TextWidthExtended>
        {width < 1072 && <TextWidth>{content}</TextWidth>}
        {width >= 1072 && <TextWidthExtended>{content}</TextWidthExtended>}
      </Figure>
    </>
  )
}

const Placeholder = styled.div`
  width: 100%;
  height: 400px;
  background-color: #e9e9e9;
`
const Figure = styled.figure`
  margin-bottom: 60px;
  line-height: 0;
  width: 100vw;
  margin: 0;
  margin-bottom: 60px;

  @media only screen and (max-width: 712px) {
    margin-bottom: 30px;
  }
`
const FigCaption = styled.figcaption`
  padding-top: 1.5rem;
  font-size: 15px;
  line-height: 21px;
  color: var(--text-color);
`
const Title = styled.div`
  font-weight: 700;
`
const Caption = styled.div``
const Source = styled.div`
  font-size: 12px;
  line-height: 18px;
`

const _Image = styled.img`
  @media only screen and (max-width: 711px) {
    margin-left: -2.7rem;
    width: calc(100% + 5.4rem);
    max-width: calc(100% + 5.4rem);
  }
`
